import type { Client, ClientWithMembers } from '@maru44/huntre-utils/src/models/client'
import type { ClientMember } from '@maru44/huntre-utils/src/models/clientMember'
import { getData } from '@maru44/huntre-utils/src/utils/data'
import { collection, doc, getDoc, getDocs } from 'firebase/firestore'
import { NotFoundError } from 'src/utils/error'
import { firestore } from 'src/utils/firebase'
import useSWR from '../useSWR'

export const useGetClientWithMembers = (id: string) => {
  const getClientWithMembers = useSWR([`/clients/${id}`, id], async (): Promise<ClientWithMembers | undefined> => {
    const ref = doc(firestore, `clients/${id}`)
    const snap = await getDoc(ref)
    if (!snap.exists) {
      throw new NotFoundError('client', id)
    }
    const client = getData<Client>(snap)

    const col = collection(firestore, `clients/${client?.id}/clientMembers`)
    const membersSnap = await getDocs(col)

    const members = membersSnap.docs.map((v) => getData<ClientMember>(v))

    const ownerRef = doc(firestore, `clients/${client.id}/clientMembers`, client.ownerMemberId)
    const ownerSnap = await getDoc(ownerRef)
    if (!ownerSnap.exists) {
      throw new NotFoundError('clientMember', id)
    }
    const owner = getData<ClientMember>(ownerSnap)

    return {
      ...client!,
      clientMembers: members!,
      ownerMember: owner!,
      createdMember: owner!,
    }
  })

  return { getClientWithMembers }
}
